import React, {useState, useEffect} from 'react';
import {Filter} from "lucide-react";
import CostSavingsRadialChart from './CostSavingCard.jsx';
import CostSavingsBar from './Costsavingbars.jsx';
import ComplianceCostSavingsCard from './ComplianceSavingsCard.jsx';
import {CostSavingsHeader} from './siteheader.jsx';
import axiosInstance from "@/api/axios";
import {useFilters} from '@/common/Components/SideBar/Layout';

const AVAILABLE_BINS = ['all', 'R1', 'R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R9', 'R13', 'R14', 'R15', 'R17', 'IST01', 'IST03', 'B1', 'B2', 'B3'];
const WASTE_TYPES = ['pmd', 'organic', 'paper'];
const TIME_PERIODS = ['Day', 'Week', 'Month', '3 Months', '6 Months', 'Year'];

export default function CostSavingsDashboard() {
    const [isFetching, setIsFetching] = useState(false);
    const [dateRange, setDateRange] = useState([null, null]);

    // Use the global filter state from Layout
    const {
        selectedBins,
        selectedTimeRange,
        selectTimeRange,
        selectedWaste,
        setSelectedWaste,
        allBins,
        timeRangeOptions,
        binDropdownOpen,
        setBinDropdownOpen,
        timeRangeDropdownOpen,
        setTimeRangeDropdownOpen,
        toggleBinSelection,
        selectedYear
    } = useFilters();

    useEffect(() => {
        const fetchBinIds = async () => {
            try {
                const response = await axiosInstance.get("bin_ids")
                const binIds = response.data || []
                // Do something with binIds if needed
            } catch (error) {
                console.error("Error fetching bin IDs:", error)
            }
        }

        // Call fetchBinIds if needed
    }, [selectedBins]);

    return (
        <div className="tab-content h-full flex flex-col">
            <CostSavingsHeader
                selectedBins={selectedBins}
                allBins={allBins}
                selectedWaste={selectedWaste}
                setSelectedWaste={setSelectedWaste}
                selectedPeriod={selectedTimeRange}
                setSelectedPeriod={selectTimeRange}
                timeRangeOptions={timeRangeOptions}
                binDropdownOpen={binDropdownOpen}
                setBinDropdownOpen={setBinDropdownOpen}
                timeRangeDropdownOpen={timeRangeDropdownOpen}
                setTimeRangeDropdownOpen={setTimeRangeDropdownOpen}
                toggleBinSelection={toggleBinSelection}
                selectedYear={selectedYear}
            />
            <div className="h-4 md:h-6"></div>
            <div className="w-full max-w-[1920px] sm:px-4 m-auto sm:pt-0 flex-grow overflow-auto">

                {/* Main Dashboard Content */}
                {/* Main Dashboard Content */}
                {isFetching ? (
                    <div className="flex items-center justify-center h-64">
                        <p>Loading data...</p>
                    </div>
                ) : (
                    <div className="h-full min-h-[500px]">
                        {/* Mobile Layout */}
                        <div className="grid grid-cols-1 gap-4 lg:hidden">
                            <div className="h-[300px]">
                                <CostSavingsRadialChart
                                    selectedBins={selectedBins}
                                    selectedPeriod={selectedTimeRange}
                                />
                            </div>
                            <div className="h-[300px]">
                                <ComplianceCostSavingsCard
                                    selectedBins={selectedBins}
                                    selectedPeriod={selectedTimeRange}
                                />
                            </div>
                            <div className="h-[300px]">
                                <CostSavingsBar
                                    selectedBins={selectedBins}
                                    selectedPeriod={selectedTimeRange}
                                />
                            </div>
                        </div>

                        {/* Desktop Layout */}
                        <div className="hidden lg:grid lg:grid-cols-4 gap-4 h-full">
                            <div className="flex flex-col gap-4 h-full">
                                <div className="flex-1">
                                    <CostSavingsRadialChart
                                        selectedBins={selectedBins}
                                        selectedPeriod={selectedTimeRange}
                                    />
                                </div>
                                <div className="flex-1">
                                    <ComplianceCostSavingsCard
                                        selectedBins={selectedBins}
                                        selectedPeriod={selectedTimeRange}
                                    />
                                </div>
                            </div>
                            <div className="lg:col-span-3 h-full">
                                <CostSavingsBar
                                    selectedBins={selectedBins}
                                    selectedPeriod={selectedTimeRange}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
